const throttle = (type, name, obj = window) => {
  let running = false;
  const func = () => {
    if (running) return;
    running = true;
    requestAnimationFrame(() => {
      const custEvent = document.createEvent('Event');
      custEvent.initEvent(name, true, true);
      obj.dispatchEvent(custEvent);
      running = false;
    });
  };
  obj.addEventListener(type, func);
};

/* init - you can init any event */
throttle('resize', 'optimizedResize');
